var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "pl-0 pt-0 pb-2 pr-0" },
    [
      !_vm.newOnly && _vm.loading
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: "spinner", size: "lg", spin: "" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading && _vm.hideNewField
        ? _c(
            "b-row",
            { staticClass: "text-left" },
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "surveyRunSelectGroup",
                        breakpoint: "md",
                        label: "Scoring Event",
                        "label-for": "surveyRunSelect",
                        validated: ""
                      }
                    },
                    [
                      _c("b-form-select", {
                        staticClass: "mb-3",
                        attrs: {
                          options: _vm.surveyRuns,
                          id: "surveyRunSelect",
                          required: _vm.required
                        },
                        on: {
                          input: function($event) {
                            _vm.selectionMade($event)
                          },
                          change: function($event) {
                            _vm.selectionMade($event)
                          }
                        },
                        model: {
                          value: _vm.selectedSurveyRun,
                          callback: function($$v) {
                            _vm.selectedSurveyRun = $$v
                          },
                          expression: "selectedSurveyRun"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading && _vm.hideNewField && !_vm.selectedSurveyRun && !_vm.noNew
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "text-left" },
                [
                  _vm.hideNewField
                    ? _c(
                        "b-button",
                        {
                          attrs: { variant: "primary" },
                          on: {
                            click: function($event) {
                              _vm.addNew()
                            }
                          }
                        },
                        [_vm._v("Add New")]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hideNewField === false,
              expression: "hideNewField === false"
            }
          ],
          staticClass: "text-left"
        },
        [
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "yearGroup",
                    breakpoint: "md",
                    label: "Year",
                    "label-for": "year",
                    validated: ""
                  }
                },
                [
                  _c("b-form-select", {
                    staticClass: "mb-3",
                    attrs: { options: _vm.years, id: "year", required: "" },
                    model: {
                      value: _vm.year,
                      callback: function($$v) {
                        _vm.year = $$v
                      },
                      expression: "year"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hideNewField === false && _vm.year,
              expression: "hideNewField === false && year"
            }
          ],
          staticClass: "text-left"
        },
        [
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "periodGroup",
                    breakpoint: "md",
                    label: "Period",
                    "label-for": "period",
                    validated: ""
                  }
                },
                [
                  _c("b-form-select", {
                    staticClass: "mb-3",
                    attrs: {
                      options: _vm.periodOptions,
                      id: "period",
                      required: ""
                    },
                    model: {
                      value: _vm.period,
                      callback: function($$v) {
                        _vm.period = $$v
                      },
                      expression: "period"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("programme-selection", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.hideNewField && _vm.period,
            expression: "!hideNewField && period"
          }
        ],
        on: {
          "update:programme": function($event) {
            _vm.programme = $event
          }
        },
        model: {
          value: _vm.programme,
          callback: function($$v) {
            _vm.programme = $$v
          },
          expression: "programme"
        }
      }),
      _vm._v(" "),
      _c("customer-selection", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.hideNewField && _vm.programme,
            expression: "!hideNewField && programme"
          }
        ],
        on: {
          "update:customer": function($event) {
            _vm.customerId = $event
          }
        },
        model: {
          value: _vm.customerId,
          callback: function($$v) {
            _vm.customerId = $$v
          },
          expression: "customerId"
        }
      }),
      _vm._v(" "),
      _c(
        "b-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hideNewField === false && _vm.customerId,
              expression: "hideNewField === false && customerId"
            }
          ],
          staticClass: "text-left"
        },
        [
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "staffGroup",
                    breakpoint: "md",
                    label: "Number of Staff",
                    "label-for": "number_of_staff",
                    validated: ""
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: { type: "number", id: "number_of_staff" },
                    model: {
                      value: _vm.number_of_staff,
                      callback: function($$v) {
                        _vm.number_of_staff = $$v
                      },
                      expression: "number_of_staff"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hideNewField === false && _vm.customerId,
              expression: "hideNewField === false && customerId"
            }
          ],
          staticClass: "text-left"
        },
        [
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "unitsGroup",
                    breakpoint: "md",
                    label: "Number of Units",
                    "label-for": "number_of_units",
                    validated: ""
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: { type: "number", id: "number_of_units" },
                    model: {
                      value: _vm.number_of_units,
                      callback: function($$v) {
                        _vm.number_of_units = $$v
                      },
                      expression: "number_of_units"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hideNewField === false && _vm.customerId,
              expression: "hideNewField === false && customerId"
            }
          ],
          staticClass: "text-left"
        },
        [
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "areaGroup",
                    breakpoint: "md",
                    label: "Areas",
                    "label-for": "area",
                    validated: ""
                  }
                },
                [
                  _c("vue-tags-input", {
                    attrs: { tags: _vm.areas, id: "area" },
                    on: {
                      "tags-changed": function(newTags) {
                        return (_vm.areas = newTags)
                      }
                    },
                    model: {
                      value: _vm.area,
                      callback: function($$v) {
                        _vm.area = $$v
                      },
                      expression: "area"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hideNewField === false && _vm.customerId,
              expression: "hideNewField === false && customerId"
            }
          ],
          staticClass: "text-left"
        },
        [
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "sponsorGroup",
                    breakpoint: "md",
                    label: "Sponsor",
                    "label-for": "sponsor",
                    validated: ""
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: { id: "sponsor" },
                    model: {
                      value: _vm.sponsor,
                      callback: function($$v) {
                        _vm.sponsor = $$v
                      },
                      expression: "sponsor"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hideNewField === false && _vm.customerId,
              expression: "hideNewField === false && customerId"
            }
          ],
          staticClass: "text-left"
        },
        [
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "sponsorContactGroup",
                    breakpoint: "md",
                    label: "Sponsor Contact Number",
                    "label-for": "sponsor_contact_number",
                    validated: ""
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: { id: "sponsor_contact_number" },
                    model: {
                      value: _vm.sponsor_contact_number,
                      callback: function($$v) {
                        _vm.sponsor_contact_number = $$v
                      },
                      expression: "sponsor_contact_number"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hideNewField === false && _vm.customerId,
              expression: "hideNewField === false && customerId"
            }
          ],
          staticClass: "text-left"
        },
        [
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "gatekeeperGroup",
                    breakpoint: "md",
                    label: "Gatekeeper",
                    "label-for": "gatekeeper",
                    validated: ""
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: { id: "gatekeeper" },
                    model: {
                      value: _vm.gatekeeper,
                      callback: function($$v) {
                        _vm.gatekeeper = $$v
                      },
                      expression: "gatekeeper"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hideNewField === false && _vm.customerId,
              expression: "hideNewField === false && customerId"
            }
          ],
          staticClass: "text-left"
        },
        [
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "gatekeeperContactGroup",
                    breakpoint: "md",
                    label: "Gatekeeper Contact Number",
                    "label-for": "gatekeeper_contact_number",
                    validated: ""
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: { id: "gatekeeper_contact_number" },
                    model: {
                      value: _vm.gatekeeper_contact_number,
                      callback: function($$v) {
                        _vm.gatekeeper_contact_number = $$v
                      },
                      expression: "gatekeeper_contact_number"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hideNewField === false && _vm.customerId,
              expression: "hideNewField === false && customerId"
            }
          ],
          staticClass: "text-left"
        },
        [
          _c(
            "b-form-checkbox",
            {
              staticClass: "ml-4 mb-3 mt-2",
              attrs: {
                id: "externalPoc",
                value: "true",
                "unchecked-value": "false",
                breakpoint: "md"
              },
              model: {
                value: _vm.external_poc,
                callback: function($$v) {
                  _vm.external_poc = $$v
                },
                expression: "external_poc"
              }
            },
            [_vm._v("\n      External POC\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hideNewField === false && _vm.customerId,
              expression: "hideNewField === false && customerId"
            }
          ],
          staticClass: "text-left"
        },
        [
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "accreditationsGroup",
                    breakpoint: "md",
                    label: "Accreditations",
                    "label-for": "accreditations",
                    validated: ""
                  }
                },
                [
                  _c("wysiwyg", {
                    attrs: { id: "accreditations" },
                    model: {
                      value: _vm.accreditations,
                      callback: function($$v) {
                        _vm.accreditations = $$v
                      },
                      expression: "accreditations"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hideNewField === false && _vm.customerId,
              expression: "hideNewField === false && customerId"
            }
          ],
          staticClass: "text-left"
        },
        [
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "customizationGroup",
                    breakpoint: "md",
                    label: "Customisation",
                    "label-for": "customization",
                    validated: ""
                  }
                },
                [
                  _c("wysiwyg", {
                    attrs: { id: "customization" },
                    model: {
                      value: _vm.customization,
                      callback: function($$v) {
                        _vm.customization = $$v
                      },
                      expression: "customization"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.hideNewField && !_vm.saving,
              expression: "!hideNewField && !saving"
            }
          ],
          staticClass: "pt-2"
        },
        [
          _c(
            "b-col",
            { staticClass: "text-left", attrs: { cols: "6" } },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "success", disabled: !_vm.customerId },
                  on: {
                    click: function($event) {
                      _vm.save()
                    }
                  }
                },
                [_vm._v("Save")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "text-right", attrs: { cols: "6" } },
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.newOnly,
                      expression: "!newOnly"
                    }
                  ],
                  attrs: { variant: "default" },
                  on: {
                    click: function($event) {
                      _vm.cancelAdd()
                    }
                  }
                },
                [_vm._v("Cancel")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.saving
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: "spinner", size: "lg", spin: "" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3076172a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3076172a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SurveyRunSelection.vue
// module id = null
// module chunks = 